import React from 'react';
import { Text } from '@/components/ui/text/Text';
import { colors } from '@/assets/styles/colors';


export interface FilterChipProps {
  label: string;
  isActive?: boolean;
  onClick?: () => void;
  showChevron?: boolean;
  /** Overrides — default to the standard filter-chip look when omitted. */
  activeBackgroundColor?: string;
  activeTextColor?: string;
  inactiveBackgroundColor?: string;
  inactiveTextColor?: string;
  labelStyle?: React.CSSProperties;
  minWidth?: number;
}

export const FilterChip: React.FC<FilterChipProps> = ({
  label,
  isActive = false,
  onClick,
  showChevron = true,
  activeBackgroundColor,
  activeTextColor,
  inactiveBackgroundColor,
  inactiveTextColor,
  labelStyle,
  minWidth = 120,
}) => (
  <button
    onClick={onClick}
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      height: 24,
      paddingLeft: 8,
      paddingRight: showChevron ? 4 : 8,
      borderRadius: 16,
      border: 'none',
      backgroundColor: isActive
        ? (activeBackgroundColor ?? colors.primary.general)
        : (inactiveBackgroundColor ?? colors.grays.neutralEE),
      cursor: 'pointer',
      minWidth,
    }}
  >
    <Text
      variant="subheader-regular"
      color={
        isActive
          ? (activeTextColor ?? colors.primary.main)
          : (inactiveTextColor ?? colors.grays.neutral66)
      }
      style={{ flex: 1, ...labelStyle }}
    >
      {label}
    </Text>
    {showChevron && (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
          d="M5 7.5L10 12.5L15 7.5"
          stroke={isActive ? colors.primary.main : colors.grays.neutral66}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )}
  </button>
);
